import { EventInfo, EventWithTeams } from '@/api/events/types/types';
import {
    notStartedStatus,
    scoreBoardSupportedLeagues,
} from '@/feature/entries-pickem/components/EntrySectionEventHeader';
import { EventStatus } from '@/types/api.generated';
import { nflFullSeason } from '@/utils/league';

import { useJurisdictionStore } from './use-jurisdiction';

export const useEventSupportsScoreboard = (event?: EventWithTeams | EventInfo) => {
    const scoreboardEnabled = useJurisdictionStore(
        state => state.jurisdictionSettings?.productConfig?.settings?.scoreboard_enabled
    );
    const pamEventId = event?.dataFeedSourceIds.find(({ source }) => source === 'PAM')?.id ?? '';
    const leagueSupportsScoreboard = scoreBoardSupportedLeagues.includes(event?.league || '');
    const isFullSeason = nflFullSeason(event?.league);
    const isFutureEvent = notStartedStatus.includes(event?.status || EventStatus.Scheduled);
    return leagueSupportsScoreboard && !isFullSeason && pamEventId && !isFutureEvent && scoreboardEnabled;
};
